import React, { useContext, useEffect, useRef, useState } from "react";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import ApexCharts from "react-apexcharts";
import { NavLink } from "react-router-dom";
import { currentDateAndTime, monthData } from "../../Constants/constants";
import GaugeChart from "react-gauge-chart";

import Select from "react-select"; 
import axios from "axios";
import { ConfigContext } from "../../Context/ConfigContext";
import { NoRecords } from "../../Components/Shimmer";
import { useNavigate } from 'react-router-dom';
import { encodeData, findModuleByRoute } from "../../Constants/constants";
import { decodeData } from "../../Constants/constants";
import { useLocation } from "react-router-dom";



const LeaveDashboard = () => {
  const { apiURL, apiHeaderJSON ,permissions} = useContext(ConfigContext);
  const locationParams = useLocation();

  const queryParams = new URLSearchParams(locationParams.search);

  const encodedData = queryParams.get("abs");
  

  const decodedData = encodedData ? decodeData(encodedData,permissions) : []; 
  const sourceDivRef = useRef(null); // Ref for the source div
  const [targetDivHeight, setTargetDivHeight] = useState("auto");
  const [monthYear, setMonthYear] = useState("");
  const inputRef = useRef(null);
  const [dailyData, setDailyData] = useState({
    employee_count: "",
    presentee_count: "",
    today_leave_count: 0,
    monthly_leave_count: "",
  });
  const [selectedMonthYear, setSelectedMonthYear] = useState(null);
  const [selectedOfferStatus, setSelectedOfferStatus] = useState("0");

  const [errors, setErrors] = useState({});
  const [monthlyAttendanceData, setMonthlyAttendanceData] = useState({
    present_rate: "0.00%",
    absence_rate: "0.00%",
  });

  const [departmentAttendanceData, setDepartmentAttendanceData] = useState([]);
const[gross,setGross] =useState([]);
  // const [attendanceData, setAttendanceData] = useState({
  //   absence_rate: "0.00%",
  //   present_rate: "0.00%",
  // });
  // const [AbsenceData,  setAbsenceData] = useState({});

  // const [PresentData, setPresentData] = useState({ });
  // const absenceRate = parseFloat(.absence_rate) / 100; // Convert "16.99%" to 0.1699
  //  const presentRate = parseFloat(attendanceData.present_rate)

  const [offerLetterStatusCounts, setOfferLetterStatusCounts] = useState({});
  const [offerSentCount, setOfferSentCount] = useState({});
  const currentDateAndTime = () => {
    return new Date().toISOString()?.slice(0, 19).replace("T", " "); // Example: '2024-12-24 15:30:00'
  };

  const currentDate = new Date();
  const currentMonth = String(currentDate.getMonth() + 1).padStart(2, "0"); // "11"
  const currentYear = currentDate.getFullYear(); // "2024"
  const [genderData, setGenderData] = useState([]);
  const [chartOptionsLeave, setChartOptionsLeave] = useState([]);
  const [leaveData, setLeaveData] = useState({
    approved_count: 0,
    pending_count: 0,
  });
  const[ chartOptionsGross, setChartOptionsGross] = useState([]);

  const [offerLetterCount, setOfferLetterCount] = useState(0);
  const [appointmentLetterCount, setappointmentLetterCount] = useState(0);
  const [selectMonthAppointment, setselectMonthAppointment] = useState("");
  const [monthYearOptions, setMonthYearOptions] = useState([]);
  const [selectMonthJoin, setSelectMonthJoin] = useState([]);

  const [departmentData, setDepartmentData] = useState([]);
  const [chartOptions, setChartOptions] = useState({});
  const [chartOptionsfGender, setChartOptionsGender] = useState({});
  const [charAttendenceData, setCharAttendenceData] = useState({});
  const [joiningData, setJoiningData] = useState({});
  const [locationCount, setLocationCount] = useState({});
  const [chartLocationOptions, setChartLocationOptions] = useState({});
  const[chartEarnedOptions,setChartEarnedOptions] = useState();
  const[departmentEarnedData,setDepartmentEarnedData]=useState();
  const[locationEarnedData,setLocationEarnedData]=useState();
  const[chartEarnedLocOptions,setChartEarnedLocOptions]=useState();
  const[departmentNetData,setDepartmentNetData]=useState();
  const[chartNetOptions,setChartNetOptions]=useState();
  const[locationNetData,setLocationNetData]=useState();
  const[chartNetLocOptions,setChartNetLocOptions]=useState();
  const[chartOverTimeOptions,setChartOverTimeOptions]=useState();
  const[departmentOverTimeData,setDepartmentOverTimeData]=useState();
  const[selectMonthOver,setSelectMonthOver]=useState();
  const[selectMonthLocOver,setSelectMonthLocOver]=useState();
  const[chartLocOverTimeOptions,setChartLocOverTimeOptions]=useState();

  
  
  // Helper function to get current month and year in "MM-YYYY" format
  const getCurrentMonthYear = () => {
    const date = new Date();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${month}-${year}`;
  };
  const [visibleDepartments, setVisibleDepartments] = useState(6); 
const navigate = useNavigate();
  const handleNavigation = () => {
    navigate(`/ApprovedLeave?abs}`);

  };

  // Generate options for the chart
  // const chartConfig = {
  //   chart: {
  //     type: 'bar',
  //     height: '30vh',
  //     toolbar: {
  //       show: true, // Show chart toolbar (optional)
  //     },
  //   },
  //   plotOptions: {
  //     bar: {
  //       horizontal: true, // Horizontal bars
  //     },
  //   },
  //   xaxis: {
  //     categories: chartOptions?.labels?.slice(0, visibleDepartments) || ["No Data"],
  //     labels: {
  //       rotate: -45, // Optional: Rotate labels for better visibility
  //     },
  //     title: {
  //       text: 'Departments', // Title of X-axis
  //     },
  //     range: visibleDepartments, // Set the range of visible departments
  //   },
  //   yaxis: {
  //     title: {
  //       text: 'Employee Count', // Y-axis title
  //     },
  //   },
  //   dataLabels: {
  //     enabled: false, // Disable data labels on the bars
  //   },
  //   grid: {
  //     show: true, // Display grid lines for better readability
  //   },
  //   legend: {
  //     position: 'bottom',
  //   },
  // };

  // Series data for the chart (Employee Count for each department)
  // const seriesData = [
  //   {
  //     name: 'Employee Count',
  //     data: chartOptions?.series?.slice(0, visibleDepartments) || [0],
  //   },
  // ];

  // {
  //   chart: {
  //     type: "area",
  //   },
  //   series: [
  //     {
  //       name: "Average Leave Of Employees",
  //       data: [50, 35, 40, 60, 49, 60, 70, 30],
  //     },
  //   ],
  //   xaxis: {
  //     categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug"],
  //   },
  //   colors: ["#687cfe"],
  // }

  
 
 

  const getLeaveTypeWiseCountList = () => {
    const headers = apiHeaderJSON;

    axios
      .get(`${apiURL}DashboardRouter/GetEmployeesOnLeaveTodayByLeaveType`, {
        params: {
          employee_status: "active",
          date: currentDateAndTime(),
          leave_date: currentDateAndTime()?.split(" ")[0],
          

        },
        headers,
      })
      .then((response) => {
        const data = response.data;
        console.log("GetEmployeesLeaveType =>", data);

        if (response.data.success === true) {
          // setLeaveData(data?.data);

          const leaveTypeName = data?.data?.map(
            (leave) => leave.leave_type_name
          );
          console.log("leaveData", leaveTypeName);
          const leaveCount = data?.data?.map((leave) => leave.leave_count);
          console.log("leaveCount", leaveCount);

          setChartOptionsLeave({
            labels: leaveTypeName || [],
            series: leaveCount || [],
          });
        } else {
          console.error("Failed to fetch leave type-wise count data.");
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  const getLeaveStatusCountList = (event) => {
    const selectLeaveMonth = event;
    const headers = apiHeaderJSON;

    axios
      .get(`${apiURL}DashboardRouter/GetEmployeesOnLeaveCountMonthWise`, {
        params: {
          request_month_year: selectLeaveMonth,
        },
        headers,
      })
      .then((response) => {
        const data = response.data;
        console.log("GetEmployeesOnLeaveCountMonthWise =>", data);

        if (response.data.success === true) {

          setLeaveData({
            ...leaveData,
            approved_count: data?.data?.approved_count || 0,
            pending_count: data?.data?.pending_count || 0,
          });

          const leaveTypeName = data?.data?.map(
            (leave) => leave.leave_type_name
          );
          console.log("leaveData", leaveTypeName);
          const leaveCount = data?.data?.map((leave) => leave.leave_count);
          console.log("leaveCount", leaveCount);

          setChartOptionsLeave({
            labels: leaveTypeName || [],
            series: leaveCount || [],
          });
        } else {
          console.error("Failed to fetch leave type-wise count data.");
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  // const getTodayLeaveList = () => {
  //   const headers = apiHeaderJSON;

  //   axios
  //     .get(`${apiURL}DashboardRouter/GetEmployeesTodaysOnLeaveCount`, {
  //       params: {
  //         date: currentDateAndTime(),
  //         leave_date: currentDateAndTime()?.split(" ")[0],
  //       },
  //       headers,
  //     })
  //     .then((response) => {
  //       const data = response.data;
  //       console.log("GetEmployeesTodaysOnLeaveCount =>", data);
  //       if (response.data.success === true) {
  //         setDailyData((prevState) => ({
  //           ...prevState,
  //           today_leave_count: data?.data[0]?.on_leave_employee_count,
  //         }));
  //       } else {
  //       }
  //     });
  // };

  const getTodayLeaveList = () => {
    const headers = apiHeaderJSON;

    axios
      .get(`${apiURL}DashboardRouter/GetEmployeesTodaysOnLeaveCount`, {
        params: {
          date: currentDateAndTime(),
          leave_date: currentDateAndTime()?.split(" ")[0], 
        },
        headers,
      })
      .then((response) => {
        const data = response.data;
        console.log("GetEmployeesTodaysOnLeaveCount =>", data, data.success);
        if (data.success === true) {
          console.log("GetEmployeesTodaysOnLeaveCount", data?.data);

          setDailyData((prevState) => ({
            ...prevState,
            today_leave_count: data?.data?.total_approved_leave_count || 0,
          }));
        } else {
          console.error("Failed to fetch data", data.message);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
      });
  };

 

  const offerStatusOptions = [
    { value: "0", label: "Offer Sent" },
    { value: "1", label: "Offer Viewed" },
    { value: "2", label: "Offer Accepted" },
    { value: "3", label: "Offer Rejected" },
    { value: "4", label: "Offer Cancelled" },
    { value: "5", label: "Offer Expired" },
  ];

  // const getofferLetter = (event, status) => {
  //   const selectMonthOffer = event;
  //   const selectedOfferStatus = status;
  //   setselectMonthAppointment(selectMonthAppointment);
  //   const headers = apiHeaderJSON;
  //   if (selectMonthOffer) {
  //     console.log(
  //       "Fetching offer letter count for month-year:",
  //       selectMonthOffer
  //     );

  //     axios
  //       .get(`${apiURL}DashboardRouter/GetOfferLetterSentCount`, {
  //         params: {
  //           request_month_year: selectMonthOffer,
  //           offer_status: selectedOfferStatus,
  //         },
  //         headers,
  //       })
  //       .then((response) => {
  //         console.log("OfferLetterCount:", response);

  //         const data = response.data;

  //         if (data.success) {
  //           console.log("Offer Letter Count:", data.offer_letter_count);
  //           setOfferLetterCount(data.data.offer_letter_count);
  //         } else {
  //           console.error(
  //             "Failed to fetch offer letter count. Message:",
  //             data.message
  //           );
  //         }
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching offer letter count:", error);
  //       });
  //   }
  // };


  
 

  
  


//   const getMonthYearOptions = () => {
//     const headers = apiHeaderJSON;
//     axios
//       .get(`${apiURL}DashboardRouter/GetAllMonthYearFromDatabase`, {
//         params: {
//           current_date: currentDateAndTime(),
//         },
//         headers,
//       })

//       .then((response) => {
//         const data = response.data;
//         console.log("MonthYearOptions =>", data);

//         if (data.success) {
//           setMonthYearOptions(data.filterData);
//         } else {
//           console.error("Failed to fetch month-year options");
//         }
//       })
//       .catch((error) => {
//         console.error("Error fetching month-year options:", error);
//       });
//   };

 
  
  
  // const getDepartmentWiseEarnedSalaryData = (event) => {
  //   const selectMonthJoin = event;
  //   setSelectMonthJoin(selectMonthJoin);
  //   const headers = apiHeaderJSON;
  
  //   axios
  //     .get(`${apiURL}DashboardRouter/GetDepartmentWiseEarnedSalary`, {
  //       params: {
  //         request_month_year: selectMonthJoin,
  //       },
  //       headers,
  //     })
  //     .then((response) => {
  //       const data = response.data;
  //       console.log("GetDepartmentWiseEarnedSalary =>", data);
  
  //       if (response.data.success === true) {
  //         const departmentTitles = data?.data?.map(dept => dept.department_name) || [];
  //         const earnedSalaries = data?.data?.map(dept => dept.total_Earned_salary) || [];
  //         const totalDepartments = departmentTitles.length;
  
  //         console.log("departmentTitles", departmentTitles);
  //         console.log("earnedSalaries?.length", earnedSalaries.length);
  
  //         setDepartmentEarnedData(totalDepartments);
  
  //         const chunkSize = 5; // Number of elements in each chunk
  
  //         // Create chunks of labels and series
  //         const chunkedTitles = [];
  //         for (let i = 0; i < departmentTitles.length; i += chunkSize) {
  //           chunkedTitles.push(departmentTitles.slice(i, i + chunkSize));
  //         }
  
  //         const chunkedSeries = [];
  //         for (let i = 0; i < earnedSalaries.length; i += chunkSize) {
  //           chunkedSeries.push(earnedSalaries.slice(i, i + chunkSize));
  //         }
  
  //         // Set chart options
  //         setChartEarnedOptions({
  //           labels: chunkedTitles || [],
  //           series: chunkedSeries.map(chunk => ({
  //             name: "Department Wise Earned Salary",
  //             data: chunk,
  //           })) || [],
  //         });
  //       } else {
  //         console.error("Failed to fetch department-wise salary data");
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching department-wise salary data:", error);
  //     });
  // };
  
  
  // const getDepartmentWiseEarnedSalaryData = (event) => {
  //   const selectedMonth = event;
  //   setSelectMonthJoin(selectedMonth);
    
  //   const headers = apiHeaderJSON;
  //   setLoading(true);
  //   axios
  //     .get(`${apiURL}DashboardRouter/GetDepartmentWiseEarnedSalary`, {
  //       params: { request_month_year: selectedMonth },
  //       headers,
  //     })
  //     .then((response) => {
  //       const { data } = response;
  //       console.log("GetDepartmentWiseEarnedSalary =>", data);
  
  //       // Ensure data exists and is in the expected structure
  //       if (data.success) {
  //         setLoading(false)
  //         const departmentTitles = data?.data?.map((dept) => dept.department_name) || [];
  //         const earnedSalaries = data?.data?.map((dept) => dept.total_Earned_salary) || [];
          
  //         console.log("departmentTitles:", departmentTitles);
  //         console.log("earnedSalaries:", earnedSalaries);
  
  //         const totalDepartments = departmentTitles.length;
  //         if (earnedSalaries.length === 0) {
  //           console.warn("No data available for the selected month.");
  //         }
  
  //         setDepartmentEarnedData(totalDepartments);
  
  //         // Chunk the data into smaller arrays for better chart handling
  //         const chunkSize = 5;
  
  //         const chunkedTitles = chunkData(departmentTitles, chunkSize);
  //         const chunkedSalaries = chunkData(earnedSalaries, chunkSize);
  
  //         // Set the chart options
  //         setChartEarnedOptions({
  //           labels: chunkedTitles || [],
  //           series: chunkedSalaries.map((chunk) => ({
  //             name: "Department Wise Earned Salary",
  //             data: chunk,
  //           })) || [],
  //         });
  //       } else {
  //         console.error("Failed to fetch department-wise salary data:", data.message || "Unknown error");
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching department-wise salary data:", error);
  //     });
  // };
  
  // Utility function to chunk an array
  // const chunkData = (data, chunkSize) => {
  //   const chunked = [];
  //   for (let i = 0; i < data.length; i += chunkSize) {
  //     chunked.push(data && data?.slice(i, i + chunkSize));
  //   }
  //   return chunked;
  // }; 

  // Utility function to chunk an array
const chunkData = (data, chunkSize) => {
  if (!Array.isArray(data)) {
    console.warn("Invalid input: data is not an array");
    return []; 
  }

  const chunked = [];
  for (let i = 0; i < data.length; i += chunkSize) {
    chunked.push(data.slice(i, i + chunkSize));
  }
  return chunked;
};

  const handleSelectChange = (name, selectedOption) => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));

    const selectedValue = selectedOption ? selectedOption.value : "";

    if (name === "month_year") {
      if (selectedValue !== selectedMonthYear) {
        setSelectedMonthYear(selectedValue);
        console.log("Month-Year changed to:", selectedValue);
        getLeaveStatusCountList(selectedValue);
        // getAppointmentLetter(selectedValue, selectedOfferStatus);
        // getofferLetter(selectedValue, selectedOfferStatus);
        // getAttendanceCountByDepartment(selectedValue);
        // getMonthlyAttendanceRates(selectedValue);
        // getAttendanceCountByDepartment(selectedValue);
        // getJoinCountMonthWise(selectedValue);
        // getDepartmentWiseEarnedSalaryData(selectedValue);
        // getLocationWiseEarnedSalaryData(selectedValue);
        // getDepartmentWiseNetSalaryData(selectedValue)
        // getLocationWiseNetSalaryData(selectedValue);
        // getDepartmentWiseOverTimeHours(selectedValue);
        // getDepartmentWiseGrossSalaryMonthWise(selectedValue);
        // getLocationWiseGrossSalaryMonthWise(selectedValue);
        // getLocationWiseOverTimeHours(selectedValue)
        setSelectedMonthYear(selectedOption?.value || null);
      }
    } else if (name === "offer_status") {
      if (selectedValue !== selectedOfferStatus) {
        setSelectedOfferStatus(selectedValue);
        console.log("Offer Status changed to:", selectedValue);
        // getofferLetter(selectedMonthYear, selectedValue);
        // getAppointmentLetter(selectedMonthYear, selectedValue);
      }
    }
  };
  const getMonthYearOptions = () => {
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}DashboardRouter/GetAllMonthYearFromDatabase`, {
        params: {
          current_date: currentDateAndTime(),
        },
        headers,
      })

      .then((response) => {
        const data = response.data;
        console.log("MonthYearOptions =>", data);

        if (data.success) {
          setMonthYearOptions(data.filterData);
          setSelectedMonthYear(Array.isArray(data.filterData) && data.filterData.length>0 && data.filterData[0]?.value);
          if(Array.isArray(data.filterData) && data.filterData.length>0){
            getLeaveStatusCountList(data.filterData[0]?.value);
          }
        } else {
          console.error("Failed to fetch month-year options");
        }
      })
      .catch((error) => {
        console.error("Error fetching month-year options:", error);
      });
  };

  useEffect(() => {
    // getList();
    // getPresentEmployeeList();
    getTodayLeaveList();
    // getDepartmentWiseCountList();
    // getLocationWiseCountList();
    // getGenderWiseCountList();
    getLeaveTypeWiseCountList();
    getMonthYearOptions();
    getCurrentMonthYear();
    if (inputRef.current) {
      flatpickr(inputRef.current, {
        dateFormat: "d M, Y",
        defaultDate: "today",
        inline: true,
      });
    }
    const sourceDiv = sourceDivRef.current;

    if (sourceDiv) {
      const resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          // Update the target div height whenever the source div resizes
          setTargetDivHeight(`${entry.contentRect.height}px`);
        }
      });

      // Observe the source div for resizing
      resizeObserver.observe(sourceDiv);

      return () => {
        // Clean up observer on component unmount
        resizeObserver.disconnect();
      };
    }
  }, []);
  const [showMore, setShowMore] = useState(false);
  const handleShowMore = () => {
    setShowMore(!showMore);
       setVisibleDepartments(showMore ? 6 : chartOptions?.labels?.length);
  };
  const renderLabels = (labels) => labels?.length > 0 ? labels : ['No Data'];
  const renderSeries = (series) => series?.length > 0 ? series : [0];

   const chartOptionsLine = {
    chart: {
      type: "line",
    },
    series: [
      {
        name: "Joins",
        data: [30, 40, 45, 50, 49, 60, 70, 91],
      },
    ],
    xaxis: {
      categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug"],
    },
    colors: ["#687cfe"],
  };

  const [currentIndex, setCurrentIndex] = useState({
    departmentWiseCountIndex:0,
    departmentWiseEarnedGrossIndex:0,
    departmentWiseNetGrossIndex:0,
    departmentWiseOverTimeHoursIndex:0,
  });
  const [animationDirection, setAnimationDirection] = useState({
    departmentWiseCountAnimation:"",
    departmentWiseEarnedGrossAnimation:"",
    departmentWiseNetGrossAnimation:"",
    departmentWiseOverTimeHoursAnimation:"",

  });
  const [currentIndex1,setCurrentIndex1]= useState(0);
  const [currentIndex2,setCurrentIndex2]= useState(0);
  const [currentIndex3,setCurrentIndex3]= useState(0);
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
   // For controlling the slide direction
  const [animating, setAnimating] = useState(false);

const handlePrev = (type) => {
if (animating) return;


  let animationClass = '';
  if (type === "1") {
    setAnimationDirection({
      ...animationDirection,
      departmentWiseCountAnimation:"slide-right",
    });
  } else if (type === "2") {
    setAnimationDirection({
      ...animationDirection,
      departmentWiseEarnedGrossAnimation:"slide-right",
    });
  } else if (type === "3") {
    setAnimationDirection({
      ...animationDirection,
      departmentWiseNetGrossAnimation:"slide-right",
    });
  } else if (type === "4") {
    setAnimationDirection({
      ...animationDirection,
      departmentWiseOverTimeHoursAnimation:"slide-right",
    });
  }
 setAnimating(true);
  setAnimationDirection(animationClass);
 
  setTimeout(() => {
    if(type==="1"){
      setCurrentIndex({
        ...currentIndex,
        departmentWiseCountIndex:(currentIndex?.departmentWiseCountIndex === 0 ? chartOptions.series.length - 1 : currentIndex?.departmentWiseCountIndex - 1),
      });
    }else if(type==="2"){
      setCurrentIndex({
        ...currentIndex,
        departmentWiseEarnedGrossIndex:(currentIndex?.departmentWiseEarnedGrossIndex === 0 ? chartEarnedOptions.series.length - 1 : currentIndex?.departmentWiseEarnedGrossIndex - 1),
      });
    }else if(type==="3"){
      setCurrentIndex({
        ...currentIndex,
        departmentWiseNetGrossIndex:(currentIndex?.departmentWiseNetGrossIndex === 0 ? chartNetOptions.series.length - 1 : currentIndex?.departmentWiseNetGrossIndex - 1),
      });
    }else if(type==="4"){
      setCurrentIndex({
        ...currentIndex,
        departmentWiseOverTimeHoursIndex:(currentIndex?.departmentWiseOverTimeHoursIndex === 0 ? chartNetOptions.series.length - 1 : currentIndex?.departmentWiseOverTimeHoursIndex - 1),
      });
      }
   
    setAnimationDirection({
      departmentWiseCountAnimation:"",
      departmentWiseEarnedGrossAnimation:"",
      departmentWiseNetGrossAnimation:"",
      departmentWiseOverTimeHoursAnimation:"",
    });
    setAnimating(false);
  }, 500); 
}
const handleNext = (type) => {
  if (animating) return;
  let animationClass = '';
  if (type === "1") {
    setAnimationDirection({
      ...animationDirection,
      departmentWiseCountAnimation:"slide-left",
    });
  } else if (type === "2") {
    setAnimationDirection({
      ...animationDirection,
      departmentWiseEarnedGrossAnimation:"slide-left",
    });
  } else if (type === "3") {
    setAnimationDirection({
      ...animationDirection,
      departmentWiseNetGrossAnimation:"slide-left",
    });
  } else if (type === "4") {
    setAnimationDirection({
      ...animationDirection,
      departmentWiseOverTimeHoursAnimation:"slide-left",
    });
  }
  setAnimating(true);
  setAnimationDirection(animationClass);
  setTimeout(() => {
    if(type==="1"){
      setCurrentIndex({
        ...currentIndex,
        departmentWiseCountIndex:(currentIndex?.departmentWiseCountIndex === chartOptions.series.length - 1 ? 0 : currentIndex?.departmentWiseCountIndex + 1),
      });
    }
    else if(type==="2"){
    setCurrentIndex({
        ...currentIndex,
        departmentWiseEarnedGrossIndex:(currentIndex?.departmentWiseEarnedGrossIndex === chartEarnedOptions.series.length - 1 ? 0 : currentIndex?.departmentWiseEarnedGrossIndex + 1),
      });
  
    } else if(type==="3"){
     setCurrentIndex({
        ...currentIndex,
        departmentWiseNetGrossIndex:(currentIndex?.departmentWiseNetGrossIndex === chartNetOptions.series.length - 1 ? 0 : currentIndex?.departmentWiseNetGrossIndex + 1),
      });
      
    }else if(type==="4"){
     setCurrentIndex({
        ...currentIndex,
        departmentWiseOverTimeHoursIndex:(currentIndex?.departmentWiseOverTimeHoursIndex === chartNetOptions.series.length - 1 ? 0 : currentIndex?.departmentWiseOverTimeHoursIndex + 1),
      });
      setCurrentIndex1((prev) => (prev === chartOverTimeOptions.series.length - 1 ? 0 : prev + 1));
    }
    
    // setCurrentIndex1((prev) => (prev === chartEarnedOptions.series.length - 1 ? 0 : prev + 1));
    // setCurrentIndex2((prev) => (prev === chartNetOptions.series.length - 1 ? 0: prev + 1));
    // setCurrentIndex3((prev) => (prev === chartOverTimeOptions.series.length - 1 ? 0: prev + 1));
     setAnimationDirection({
      departmentWiseCountAnimation:"",
      departmentWiseEarnedGrossAnimation:"",
      departmentWiseNetGrossAnimation:"",
      departmentWiseOverTimeHoursAnimation:"",
     });
    setAnimating(false);

  }, 500); // Match the CSS transition duration
};
  
  // const absenceRate = parseFloat(.absence_rate) / 100; // Convert "16.99%" to 0.1699
  // const presentRate = parseFloat(attendanceData.present_rate)
  return (
    <>
    <div className="card p-2">
       <div className="row col-md-12 mt-3">
          <div className="col-xl-3">
            <div className="card card-animate">
              <div className="card-body">
                <div className="d-flex align-items-center">
                  <div className="avatar-sm flex-shrink-0">
                    <span className="avatar-title bg-success-subtle text-success rounded-2 fs-2">
                      <i className="bx ri-calendar-event-line text-success" />
                    </span>
                  </div>
                  <div className="flex-grow-1 overflow-hidden ms-3 cursor-pointer hover-effect" onClick={handleNavigation}>
                    <p className="text-uppercase fw-medium text-muted text-truncate mb-3">
                      On Leave
                    </p>
                    <div className="d-flex align-items-center mb-3 ">
                      <h4 className="flex-grow-1 mb-0">
                        <span className="counter-value" data-target={0}>
                          {dailyData?.today_leave_count || 0}
                        </span>
                      </h4>
                      {/* <span className="badge bg-danger-subtle text-danger fs-12">
                        <i className="ri-arrow-down-s-line fs-13 align-middle me-1" />
                        5.35 %
                      </span> */}
                    </div>
                    <p className="text-muted text-truncate mb-0">
                      Today On Leave
                    </p>
                  </div>
                </div>
              </div>

              {/* end card body */}
            </div>
          </div>  
          <div className="col-xl-3">
            <div className="card p-2">
              <div>
                <div className="text-center mt-3">
                  <h5>Leave Type Wise Count</h5>
                </div>
              </div>
              
              {/* <ApexCharts
  options={{
    chart: {
      type: "donut",
      height: "30vh",
    },
    labels:
      Array.isArray(chartOptionsLeave.labels) && chartOptionsLeave.labels.length > 0
        ? chartOptionsLeave.labels
        : ["No Data Available"],
    legend: {
      position: "bottom",
      labels: {
        colors: ["#000"], 
        useSeriesColors: false,
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: "65%",
          labels: {
            show: false,
            name: {
              show: true,
              color: "#000",
            },
            value: {
              show: true,
              formatter: (val, opts) => {
                
                const seriesIndex = opts?.seriesIndex;
                return chartOptionsLeave?.series?.[seriesIndex] ?? 0; // Default to 0 if data is unavailable
              },
              color: "#000", 
            },
          },
        },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val, opts) => {
        
        const seriesIndex = opts?.seriesIndex;
        return chartOptionsLeave?.series?.[seriesIndex] ?? 0; 
      },
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: (val) => val ?? 0, 
      },
    },
    colors:
      Array.isArray(chartOptionsLeave.series) && chartOptionsLeave.series.length > 0
        ? undefined
        : ["#E0E0E0"], 
  }}
  series={
    Array.isArray(chartOptionsLeave.series) && chartOptionsLeave.series.length > 0
      ? chartOptionsLeave.series
      : [0] 
  }
  type="donut"
/> */}
<div className="chart-container">
  {Array.isArray(chartOptionsLeave?.series) && chartOptionsLeave.series.some((value) => value > 0) ? 
  (
    <ApexCharts
      options={{
        chart: {
          type: "donut",
          height: "30vh",
        },
        labels:
          Array.isArray(chartOptionsLeave.labels) && chartOptionsLeave.labels.length > 0
            ? chartOptionsLeave.labels
            : ["No Data Available"],
        legend: {
          position: "bottom",
          labels: {
            colors: ["#000"],
            useSeriesColors: false,
          },
        },
        plotOptions: {
          pie: {
            donut: {
              size: "65%",
              labels: {
                show: false,
                name: {
                  show: true,
                  color: "#000",
                },
                value: {
                  show: true,
                  formatter: (val, opts) => {
                    const seriesIndex = opts?.seriesIndex;
                    return chartOptionsLeave?.series?.[seriesIndex] ?? 0;
                  },
                  color: "#000",
                },
              },
            },
          },
        },
        dataLabels: {
          enabled: true,
          formatter: (val, opts) => {
            const seriesIndex = opts?.seriesIndex;
            return chartOptionsLeave?.series?.[seriesIndex] ?? 0;
          },
        },
        tooltip: {
          enabled: true,
          y: {
            formatter: (val) => val ?? 0,
          },
        },
        colors:
          Array.isArray(chartOptionsLeave.series) && chartOptionsLeave.series.length > 0
            ? undefined
            : ["#E0E0E0"],
      }}
      series={Array.isArray(chartOptionsLeave.series) && chartOptionsLeave.series.length > 0
        ? chartOptionsLeave.series
        : [0, 0, 0]}
      type="donut"
    />
  ) : (
    <div
      className="  rounded-2 mt-1 py-3">
      <p className=" text-center">No Leaves For Today</p>
    </div>
  )}
</div>


          
            </div>
          </div>       
          {/* <div className="col-md-3">
            <div className="card card-animate">
              <div className="card-body">
                <div className="d-flex align-items-center">
                  <div className="avatar-sm flex-shrink-0">
                    <span className="avatar-title bg-success-subtle text-success rounded-2 fs-2">
                      <i className="bx ri-calendar-event-line text-success" />
                    </span>
                  </div>
                  <div className="flex-grow-1 overflow-hidden ms-3">
                    <p className="text-uppercase fw-medium text-muted text-truncate mb-3">
                      Approved Leave
                    </p>
                    <div className="d-flex align-items-center mb-3">
                      <h4 className="flex-grow-1 mb-0">
                        <span className="counter-value" data-target={0}>
                          {leaveData?.approved_count  || 0}
                        </span>
                      </h4>
                      {/* <span className="badge bg-danger-subtle text-danger fs-12">
                        <i className="ri-arrow-down-s-line fs-13 align-middle me-1" />
                        5.35 %
                      </span> 
                    </div>
                    <p className="text-muted text-truncate mb-0">
                      Monthly Approved Leave
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          <div className="col-md-6">
            <div className="row">
                <div className="col-md-12">
                  <div className="card-body pt-0 ">
                    <label htmlFor="month_year" className="form-label">
                      Month Year:
                    </label>
                    <Select
                      id="month_year"
                      name="month_year"
                      value={selectedMonthYear? monthYearOptions.find((option) => option.value === selectedMonthYear): null}
                      onChange={(selectedOption) =>
                        handleSelectChange("month_year", selectedOption)
                      }
                      options={monthYearOptions}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card card-animate">
                    <div className="card-body">
                      <div className="d-flex align-items-center">
                        <div className="avatar-sm flex-shrink-0">
                          <span className="avatar-title bg-success-subtle text-success rounded-2 fs-2">
                            <i className="bx ri-calendar-event-line text-success" />
                          </span>
                        </div>
                        <div className="flex-grow-1 overflow-hidden ms-3">
                          <p className="text-uppercase fw-medium text-muted text-truncate mb-3">
                            Unapproved Leave
                          </p>
                          <div className="d-flex align-items-center mb-3">
                            <h4 className="flex-grow-1 mb-0">
                              <span className="counter-value" data-target={0}>
                                {leaveData?.pending_count  || 0}
                              </span>
                            </h4>
                            {/* <span className="badge bg-danger-subtle text-danger fs-12">
                              <i className="ri-arrow-down-s-line fs-13 align-middle me-1" />
                              5.35 %
                            </span> */}
                          </div>
                          <p className="text-muted text-truncate mb-0">
                            Monthly Unapproved Leave
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card card-animate">
                    <div className="card-body">
                      <div className="d-flex align-items-center">
                        <div className="avatar-sm flex-shrink-0">
                          <span className="avatar-title bg-success-subtle text-success rounded-2 fs-2">
                            <i className="bx ri-calendar-event-line text-success" />
                          </span>
                        </div>
                        <div className="flex-grow-1 overflow-hidden ms-3">
                          <p className="text-uppercase fw-medium text-muted text-truncate mb-3">
                            Approved Leave
                          </p>
                          <div className="d-flex align-items-center mb-3">
                            <h4 className="flex-grow-1 mb-0">
                              <span className="counter-value" data-target={0}>
                                {leaveData?.approved_count  || 0}
                              </span>
                            </h4>
                            {/* <span className="badge bg-danger-subtle text-danger fs-12">
                              <i className="ri-arrow-down-s-line fs-13 align-middle me-1" />
                              5.35 %
                            </span> */}
                          </div>
                          <p className="text-muted text-truncate mb-0">
                            Monthly Approved Leave
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
          
        </div>
    </div>
    </>
  );
};
export default LeaveDashboard;
